export const DISPLAY_OPTIONS='options'

export const DISPLAY_SINGLE= 'single'

export const DISPLAY_BATCH= 'batch'

export const DISPLAY_LOADING='loading'

export const DISPLAY_SUCCESS='success'